import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useMotionTemplate, useScroll, useTransform } from "framer-motion";

export const Showroom = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "center center"] });
  const inset = useTransform(scrollYProgress, [0, 1], [14, 0]);
  const radius = useTransform(scrollYProgress, [0, 1], [28, 0]);
  const clip = useMotionTemplate`inset(${inset}% ${inset}% ${inset}% ${inset}% round ${radius}px)`;
  const scale = useTransform(scrollYProgress, [0, 1], [1.25, 1]);

  return (
    <section ref={ref} className="bg-ivory" data-testid="showroom-section">
      <motion.div style={{ clipPath: clip }} className="relative h-[70svh] overflow-hidden md:h-[92svh]">
        <motion.img style={{ scale }} src="/img/showroom.webp" alt="All six MARKHOR colors displayed in the showroom" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 mx-auto flex max-w-[1600px] flex-col gap-6 px-5 pb-10 text-white md:flex-row md:items-end md:justify-between md:px-10 md:pb-14">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D8DCE0]">The lineup</p>
            <p className="mt-3 max-w-xl font-display text-4xl font-light leading-[1] md:text-6xl">Six colors. <em>One silhouette.</em></p>
          </div>
          <Link to="/shop" data-testid="showroom-explore-button" className="btn-light self-start md:self-auto">Explore collection</Link>
        </div>
      </motion.div>
    </section>
  );
};
